/* dynamic-layout-foldable-section.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./dynamic-layout-foldable-section.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@compiled/react';
import { IconButton } from '@atlaskit/button/new';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import { Box, Pressable, Text } from '@atlaskit/primitives/compiled';
import { OneColumnLayout } from './section-layout/one-column-layout';
var styles = {
  container: "_kqswh2mm",
  foldableStyle: "_2rko12b0 _zulpu2gc _v564mfn2 _1e0c1txw _2lx21bp4 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1e5h _bfhkvuon _16qst7xp _1bsb1osq",
  foldedStyle: "_80omtlke _irr33v15",
  innerContainer: "_1reo15vq _18m915vq _4t3iqslr _1e0ccj1k _sudp1e54 _1yyjkb7n",
  contentWrapper: "_1reo15vq _18m915vq _v5641hv1",
  contentExpanded: "_c71ldgin",
  contentCollapsed: "_c71lqslr",
  collapseButtonStyle: "_v5641lvb _kqswstnw _154iu2gc _1xi2u2gc",
  collapseButtonHidden: "_3um015vq _lcxvglyw"
};
export var DynamicLayoutFoldableSection = function DynamicLayoutFoldableSection(_ref) {
  var _section$attributes;
  var section = _ref.section,
    header = _ref.header,
    content = _ref.content,
    children = _ref.children;
  var _React$useState = React.useState(((_section$attributes = section.attributes) === null || _section$attributes === void 0 ? void 0 : _section$attributes.folded) === '1'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isFolded = _React$useState2[0],
    setIsFolded = _React$useState2[1];
  var renderContent = function renderContent() {
    if (isFolded) {
      var _header$attributes;
      return /*#__PURE__*/React.createElement(Pressable, {
        xcss: cx(styles.foldableStyle, styles.foldedStyle),
        onClick: function onClick() {
          setIsFolded(false);
        }
      }, header && ((_header$attributes = header.attributes) === null || _header$attributes === void 0 ? void 0 : _header$attributes.show) !== 'false' && content && /*#__PURE__*/React.createElement(Text, {
        weight: "bold"
      }, header && header.children), /*#__PURE__*/React.createElement(Box, {
        xcss: cx(styles.contentWrapper, isFolded ? styles.contentCollapsed : styles.contentExpanded)
      }, /*#__PURE__*/React.createElement(Box, {
        xcss: styles.innerContainer
      }, /*#__PURE__*/React.createElement(OneColumnLayout, {
        elements: content
      }))));
    } else {
      var _header$attributes2;
      return /*#__PURE__*/React.createElement(Box, {
        xcss: cx(styles.foldableStyle)
      }, header && ((_header$attributes2 = header.attributes) === null || _header$attributes2 === void 0 ? void 0 : _header$attributes2.show) !== 'false' && content && /*#__PURE__*/React.createElement(Text, {
        weight: "bold"
      }, header && header.children), /*#__PURE__*/React.createElement(Box, {
        xcss: cx(styles.contentWrapper, isFolded ? styles.contentCollapsed : styles.contentExpanded)
      }, children));
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.container
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.collapseButtonStyle, isFolded && styles.collapseButtonHidden)
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: ChevronUpIcon,
    label: "Collapse section",
    appearance: "subtle",
    spacing: "compact",
    onClick: function onClick() {
      return setIsFolded(true);
    }
  })), renderContent());
};